import { useMemo } from 'react'
import type { Contact } from '@/types'

export function createContactMap(contacts: Contact[]): Map<string, Contact> {
  return new Map(contacts.map((contact) => [contact.wxid, contact]))
}

export function useContactMap(contacts: Contact[]): Map<string, Contact> {
  return useMemo(() => createContactMap(contacts), [contacts])
}
